import { HttpStatusCode } from 'axios';
import { PaymentStatus, PlanStatus } from 'src/utils/constants/enum';
import { TypePlanCategory, TypeUserCreditUsage } from 'src/utils/typings/dto/payment';
import { ICampaignDetail, IListPlanWithCampaign, IPlanDetail } from 'src/utils/typings/response';
import {
  IBillingDetail,
  ICheckoutSession,
  ICreateIntentTransfer,
  ICustomerId,
  IInvoiceDetail,
  IPaymentHistory,
  ITeamManageChartsSection,
  ITeamMember,
  IUsageInformation,
  IUserSidebar
} from 'src/utils/typings/response/payment';

export class CustomerId implements IResponse<ICustomerId> {
  message?: string | undefined;
  status_code: number;
  data: ICustomerId;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      id: '',
    };
  }
}

export class CheckoutSession implements IResponse<ICheckoutSession> {
  message?: string | undefined;
  status_code: number;
  data: ICheckoutSession;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      sessionId: '',
    };
  }
}

export class CreateIntentTransfer implements IResponse<ICreateIntentTransfer> {
  message?: string | undefined;
  status_code: number;
  data: ICreateIntentTransfer;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      email: '',
      hosted_instructions_url: '',
      amount: 150,
      currency: '',
      funding_instructions: {
        bank_name: '',
        swift_code: '',
        account_type: '',
        bank_address: {
          city: '',
          line1: '',
          line2: '',
          state: '',
          country: '',
          postal_code: '',
        },
        account_number: '',
        routing_number: '',
        account_holder_name: '',
        account_holder_address: {
          city: '',
          line1: '',
          line2: '',
          state: '',
          country: '',
          postal_code: '',
        },
      },
      funding_type: '',
      reference: '',
      bank_transfer_type: '',
      payment_method_type: '',
      price_id: '',
      payment_intent_id: '',
      interval: '',
      created_at: '',
      plan_id: 0,
      interval_count: 0,
      stripe_customer_id: '',
      status: '',
      user_uuid: '',
      id: '',
      client_secret: '',
    };
  }
}

export class BillingDetail implements IResponse<IBillingDetail> {
  message?: string | undefined;
  status_code: number;
  data: IBillingDetail;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      id: 0,
      email: '',
      last_name: '',
      phone_number: '',
      country: '',
      city: '',
      postal_code: '',
      user_uuid: '',
      first_name: '',
      company_name: '',
      region: '',
      address: '',
      vat_id: '',
    };
  }
}

export class ListPlans implements IResponse<IListPlanWithCampaign> {
  message?: string | undefined;
  status_code: number;
  data: IListPlanWithCampaign;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      plans: [],
      campaign: {
        id: '',
        slug: '',
        promotion_code: '',
        description: '',
        status: '',
        call_to_action: '',
        name: '',
        created_at: '',
        plans: [],
      },
    };
  }
}

export class PlanDetail implements IResponse<IPlanDetail> {
  message?: string | undefined;
  status_code: number;
  data: IPlanDetail;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      id: 0,
      plan_name: '',
      short_description: '',
      benefits: [],
      benefits_yearly: [],
      status: PlanStatus.Active,
      display_for_sale: true,
      price_monthly: null,
      price_quarterly: null,
      price_half_yearly: null,
      price_yearly: null,
      credit_points_per_month: null,
      credit_points_per_month_yearly: null,
      stripe_price_id_quarterly: '',
      stripe_price_id_half_yearly: '',
      stripe_price_id_yearly: '',
      stripe_product_id: '',
      stripe_price_id_monthly: '',
      created_at: null,
      updated_at: null,
      expired_at: null,
      is_trial: false,
      trial_duration: 0,
      is_freemium: false,
      sort_order: null,
    };
  }
}

export class ListInvoices implements IResponseList<IPaymentHistory> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IPaymentHistory[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class InvoiceDetail implements IResponse<IInvoiceDetail> {
  message?: string | undefined;
  status_code: number;
  data: IInvoiceDetail;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      invoice: {
        invoice_id: '',
        payment_method: '',
        paid_at: '',
        status: PaymentStatus.void,
      },
      billed_to: {
        full_name: '',
        phone_number: '',
        email: '',
      },
      items: {
        plan_name: '',
        plan_type: '',
        amount: 0,
      },
      details: {
        date_issued: '',
        due_date: '',
        total: 0,
      },
    };
  }
}

export class InvoiceStripeDetail implements IResponse<ExpectedAny> {
  message?: string | undefined;
  status_code: number;
  data: ExpectedAny;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {};
  }
}

export class UsageInformation implements IResponse<IUsageInformation> {
  message?: string | undefined;
  status_code: number;
  data: IUsageInformation;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      role: '',
      usage_total: 0,
      members: 0,
      usage_date: '',
      current_usage: 0,
      user_uuid: '',
      id: 0,
      total_members: 0,
      current_product: '',
      renewal_date: '',
      created_at: '',
      invoice_amount: 0,
      period_end: '',
      subscription_id: '',
      features: [],
      is_trial: false,
      status: 'active',
      team_id: 0,
    };
  }
}
export class PlanFeatures implements IResponseList<TypePlanCategory> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: TypePlanCategory[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}
export class UserCreditUsages implements IResponseList<TypeUserCreditUsage> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: TypeUserCreditUsage[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class UserSidebars implements IResponse<IUserSidebar[]> {
  message?: string | undefined;
  status_code: number;
  warning?: string | null | undefined;
  data: IUserSidebar[];
  errors?: any[] | undefined;
  httpStatus?: number | undefined;
  constructor() {
    ((this.status_code = HttpStatusCode.Ok), (this.data = []));
  }
}

export class CampaignDetail implements IResponse<ICampaignDetail> {
  message?: string | undefined;
  status_code: number;
  data: ICampaignDetail;
  constructor() {
    this.message = '';
    this.status_code = 0;
    this.data = {
      id: '',
      slug: '',
      promotion_code: '',
      description: '',
      status: '',
      call_to_action: '',
      name: '',
      created_at: '',
      plans: [],
    };
  }
}

export class TeamMembers implements IResponseList<ITeamMember> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITeamMember[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class TeamManageChartsSection implements IResponse<ITeamManageChartsSection> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITeamManageChartsSection;
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    ((this.status_code = 200), (this.data = {}));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}
